<nv-icon *ngIf="hasIcon" [name]="iconName"></nv-icon> <span class="nv-note-content"> <ng-content #textContent></ng-content> </span>

<nv-button *ngIf="hasAction" (click)="handleClick($event)" type="note" size="small">
    {{ actionText }}
</nv-button>